import { Component } from '@angular/core';

@Component({
  selector: 'app-main-demos',
  templateUrl: './main-demos.component.html',
  styleUrl: './main-demos.component.css'
})
export class MainDemosComponent {
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  chooserTemplate =[
    {
      img:'demo-1.jpg',
      url:'/home-one',
      text:'Home Default'
    },
    {
      img:'demo-2.jpg',
      url:'/home-two',
      text:'Home Parallax'
    },
    {
      img:'demo-3.jpg',
      url:'/home-three',
      text:'Home Video'
    },
    {
      img:'demo-4.jpg',
      url:'/home-four',
      text:'Home Video Popup'
    },
    {
      img:'demo-5.jpg',
      url:'/home-five',
      text:'Home Gradient'
    },
    {
      img:'demo-6.jpg',
      url:'/home-six',
      text:'Home Slider'
    }

  ];

  serviceItems = [
    { icon: 'bi-person-workspace', title: 'Fullscreen Video' },
    { icon: 'bi-brush', title: 'Color Variations' },
    { icon: 'bi-camera', title: '6 Different layouts' },
    { icon: 'bi-gear', title: 'User Friendly' },
    { icon: 'bi-bootstrap', title: 'Bootstrap 5x' },
    { icon: 'bi-phone', title: 'Animated Gradient' }
  ];
}
